import logo from '../../logo/utd.png'

function Admissions() {
    return (
        <div className='m-4 xl:mx-20 xl:mt-10'>
            <p className='font-bold xl:text-2xl opacity-70'>
                The University of Texas at Dallas > Admissions
            </p>
            <p className='mt-4 xl:mt-10 font-bold text-4xl xl:text-7xl'>
                Admissions
            </p>
            <p className='mt-4 xl:mt-10 text-lg xl:text-2xl leading-10'>
                Join a rising public research university with top programs 
                in STEM, management, liberal arts and social sciences. 
                Explore the application process, admission resources and more.
            </p>
            <img className="mt-10" src={logo} alt="logo" />
            <p className='mt-4 mb-40 xl:mt-10 text-lg xl:text-2xl leading-10'>
            UT Dallas provides some of the state's most-lauded business, 
            engineering and science programs, and has also gained prominence 
            for a wide breadth of academic specialties, from audiology to biomedical 
            engineering to public affairs.
            </p>
        </div>
    )
}

export default Admissions;